import styled from "styled-components";
import { colors } from "utils/theme";

export const Wrapper = styled.div`
  background: ${colors.midnight};
`;
